import { render } from "./DownloadVimass.vue?vue&type=template&id=0dcac62d"
import script from "./DownloadVimass.vue?vue&type=script&lang=js"
export * from "./DownloadVimass.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__